import styled from 'styled-components'

export const Container = styled.div`
  /* padding: 20px 100px;
  position: fixed;
  width: 100vw; */
  position: fixed;
  max-width: 1440px;
  width: 100%;
  background-color: #fff;
  z-index: 9;
  @media only screen and (max-width: 1024px) {
    height: 86px;
  }
`

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px !important;
  padding: 0 100px;

  img {
    height: 36px;
    @media only screen and (max-width: 1024px) {
      height: 38px;
    }
  }

  img {
    width: 95px;

    @media only screen and (max-width: 600px) {
      /* width: 80%; */
      /* margin: auto; */
    }

    @media only screen and (max-width: 768px) {
      /* width: 80%; */
      width: 102px;
    }
  }

  @media (max-width: 1024px) {
    padding: 0 75px;
  }

  @media only screen and (max-width: 600px) {
    /* width: 80%; */
    padding: 0 20px;
  }

  /* @media only screen and (min-width: 1200px) {
    justify-content: flex-start;
  } */
`

export const LogoItem = styled.div`
  /* width: 75%; */

  img {
    margin-left: 15px;
  }

  /* @media (max-width: 1024px) {
    width: 100vw;

    a {
      display: flex;
      width: 102px;
    }

    img {
      display: flex;
    }
  }

  @media (max-width: 600px) {
    position: absolute;
    margin: -20px;
    top: 40px;
  }



  @media only screen and (min-width: 1024px) {
    img {
      display: flex;
      margin: auto;
      width: 95px;
    }
  } */

  @media (min-width: 600px) and (max-width: 1024px) {
    position: absolute;
    margin-left: 0px;
    top: 20px;
    img {
      display: flex;
      margin: auto;
    }
  }
`

export const Navbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;

  @media only screen and (max-width: 600px) {
    // position: absolute;
    // right: -20vw;
    margin-left: auto;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    position: absolute;
    right: 75px;
  }
`

export const LinkSearch = styled.div`
  a {
    color: #00095b;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    text-decoration: none;

    @media only screen and (max-width: 800px) {
      position: absolute;
      right: 55px;
    }

    @media only screen and (max-width: 600px) {
      // position: absolute;
      // right: -20vw;
      margin-left: auto;
    }
  }
`

export const LinkInteractiveExperience = styled.div`
  a {
    color: #00095b;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    text-decoration: none;
    font-family: FordAntennaCondRegular;
    font-weight: bolder;
    letter-spacing: 0.5px;

    @media only screen and (max-width: 812px) {
      display: none;
    }

    @media only screen and (max-width: 600px) {
      // position: absolute;
      // right: -20vw;
      margin-left: auto;
    }
  }
`

export const SearchItem = styled.div`
  width: 24px;
  height: 28px;

  img {
    width: 100%;
  }

  span {
    font-size: 1.7rem !important;
  }
`

export const BurgerMenuWrapper = styled.div`
  font-size: 30px;
  cursor: pointer;

  @media only screen and (min-width: 812px) {
    display: none;
  }
`

export const LinksWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  min-width: 460px;

  @media only screen and (max-width: 812px) {
    display: none;
  }
`

export const MobileMenu = styled.div`
  padding: 30px;
  background-color: white;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);

  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`

export const MobileMenuItem = styled.div`
  border-top: 1px solid lightgray;
  padding: 15px 0;
`

export const ButtonSecondary = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 30px;
  a {
    color: #00095b;
    font-size: 18px;
    letter-spacing: 1px;
    line-height: 24px;
    text-align: center;
    text-decoration: none;
    font-family: 'FordAntennaCondRegular';

    &:hover {
      color: #1700f4;
      text-decoration: underline;
    }
  }
`
